import * as yup from 'yup';

import { StringTypeBase } from '../../types/baseTypes/StringTypeBase';
import { AllTypeContexts } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_TEXT } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use StringType from application-types instead.
 */
/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use StringType from application-types instead.
 */
export class StringType extends StringTypeBase {
  contexts = AllTypeContexts;

  group = TYPE_GROUP_TEXT;

  name = 'String';

  friendlyName = 'Text';

  get example() {
    return 'Lorem ipsum';
  }

  get default(): any {
    return '';
  }

  buildSchema() {
    return yup.string().nullable();
  }
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use String from application-types instead.
 */
/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use String from application-types instead.
 */
const definition = new StringType();

Types.addBaseType(definition);
export default definition;
